/** User-facing messages for Smart Attendance — never surface raw backend dumps. */

const SAFE_DETAIL_MAX = 180;

function isSafeDetail(detail) {
  if (typeof detail !== "string") return false;
  if (!detail.trim() || detail.length > SAFE_DETAIL_MAX) return false;
  if (/traceback|exception|mongo|pymongo|sqlalchemy|stack|internal server/i.test(detail)) {
    return false;
  }
  return true;
}

export function attendanceErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  if (!err) return fallback;
  if (!err.response) {
    return "Network error. Check your connection and try again.";
  }
  const status = err.response.status;
  const detail = err.response?.data?.detail;

  if (status === 401) {
    return "Your session expired. Please sign in again.";
  }
  if (status === 404) {
    return isSafeDetail(detail) ? detail : "This attendance QR code is unavailable.";
  }
  if (status === 409) {
    return isSafeDetail(detail)
      ? detail
      : "You are already checked in at another site. Check out there first.";
  }
  if (status === 422) {
    return isSafeDetail(detail)
      ? detail
      : "Location could not be verified for this site.";
  }
  if (status === 403) {
    return isSafeDetail(detail) ? detail : "You do not have permission for this action.";
  }
  if (status === 429) {
    return "Please wait a moment before trying again.";
  }
  if (status >= 500) {
    return "Service temporarily unavailable. Please try again.";
  }
  if (isSafeDetail(detail)) return detail;
  return fallback;
}

export function locationOutcomeLabel(outcome) {
  const map = {
    within_radius: "On site — location verified",
    outside_radius: "Outside the site area",
    poor_accuracy: "Low GPS accuracy",
    permission_denied: "Location access denied",
    unavailable: "Location unavailable",
  };
  return outcome ? map[outcome] || null : null;
}

export function eventTypeLabel(type) {
  const map = {
    check_in: "Check in",
    check_out: "Check out",
    check_in_denied: "Check-in denied",
    open_session_conflict: "Conflict",
    temporary_away: "Away (lunch)",
    temporary_return: "Return",
    temporary_return_late: "Return (after grace)",
  };
  return map[type] || type || "Event";
}
